<template>
  <div>
    <shifts-counter-view-single :isManagementEvaluation="isManagementEvaluation"
                                :value="value"/>
  </div>
</template>

<script>
  import ShiftsCounterViewSingle from '@/components/shifts-counter/ShiftsCounterViewSingle';

  export default {
    name: 'ShiftsCounterReminder',
    components: { ShiftsCounterViewSingle },
    props: {
      environment: {
        type: String,
        required: true,
      },
      isManagementEvaluation: {
        type: Boolean,
        default: false,
      },
      shiftsCounterData: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      value() {
        if (this.shiftsCounterData[this.environment]) {
          return this.shiftsCounterData[this.environment];
        }
        let environmentWithEndStations = '';
        Object.entries(this.shiftsCounterData).forEach(([key, value]) => {
          if (this.hasProperty(value, 'end_stations')) {
            if (Object.keys(value.end_stations).includes(this.environment)) {
              environmentWithEndStations = key;
            }
          }
        });
        if (environmentWithEndStations.length) {
          return this.shiftsCounterData[environmentWithEndStations];
        }
        return {};
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
